import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { locationAtom } from '../../contexts/AtomUtil'

function LocationBridge() {
  const location = useLocation()
  const setLocation = useSetAtom(locationAtom)

  useEffect(() => {
    setLocation(location)
  }, [location, setLocation])

  return null
}

export default LocationBridge
